import { render } from "./PauseButton.vue?vue&type=template&id=5166130c&scoped=true&ts=true"
import script from "./PauseButton.vue?vue&type=script&lang=ts"
export * from "./PauseButton.vue?vue&type=script&lang=ts"

import "./PauseButton.vue?vue&type=style&index=0&id=5166130c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5166130c"]])

export default __exports__